import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { ApiResponse } from '@/types/addContainerBlExportType';

type Validated = {
  oidLiquidacion: number;
  oidVisita: number;
  entregaDirecta: boolean;
  fechaRetiro: string;
};

export const addContainerBlImport = async (
  query: Validated
): Promise<ApiResponse['value']> => {
  try {
    const res = await apiClient.post<ApiResponse>(
      Endpoints.AddContainersBLImport,
      query
    );
    if (res?.data?.value?.ok === false) {
      throw new Error(res?.data?.value?.mensaje);
    }

    if (res?.data?.value?.error) {
      throw new Error(res?.data?.value?.error);
    }

    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
